var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3496 1.45724C10.5437 1.32907 10.8077 1.35083 10.9785 1.52169L13.4785 4.02169C13.6738 4.21695 13.6738 4.53346 13.4785 4.72872L5.35352 12.8537C5.25975 12.9475 5.13261 13.0002 5 13.0002H2.5C2.22386 13.0002 2 12.7763 2 12.5002V10.0002C2 9.8676 2.05272 9.74046 2.14648 9.64669L10.2715 1.52169L10.3496 1.45724ZM12.8125 12.0002L12.9131 12.01C13.1411 12.0565 13.3125 12.2585 13.3125 12.5002C13.3125 12.7419 13.1411 12.9439 12.9131 12.9904L12.8125 13.0002H7.5C7.22386 13.0002 7 12.7763 7 12.5002C7 12.2241 7.22386 12.0002 7.5 12.0002H12.8125ZM3 10.2072V12.0002H4.79297L10.543 6.25021L8.75 4.45724L3 10.2072ZM9.45703 3.75021L11.25 5.54318L12.418 4.37521L10.625 2.58224L9.45703 3.75021Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyEditIcon);
export default __webpack_public_path__ + "static/media/GreyEditIcon.ac82f0e05d6217922f8d67b51be4bcb9.svg";
export { ForwardRef as ReactComponent };